/* eslint-disable import/no-anonymous-default-export */
import en from './en-US'
export default {
  en,
}